import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './FileTypeFilter.module.css';

const fileTypeFilter = (props) => {
  const containerClasses = [classes.Container];
  if (props.show) containerClasses.push(classes.Open);
  return (
    <div className={containerClasses.join(' ')}>
      <div className={classes.ImageOptions}>
        <div
          onClick={() => props.select('image', 'fileType')}
          className={props.fileType === 'image' ? [classes.ImageOption, classes.Selected].join(' ') : classes.ImageOption}
        >
          <FontAwesomeIcon icon="check" className={classes.CheckMark} />
          <h3>Only show posts with images</h3>
        </div>
        <div
          onClick={() => props.select('no_image', 'fileType')}
          className={props.fileType === 'no_image' ? [classes.ImageOption, classes.Selected].join(' ') : classes.ImageOption}
        >
          <FontAwesomeIcon icon="check" className={classes.CheckMark} />
          <h3>Only show posts with no images</h3>
        </div>
        <div
          onClick={() => props.select('video', 'fileType')}
          className={props.fileType === 'video' ? [classes.ImageOption, classes.Selected].join(' ') : classes.ImageOption}
        >
          <FontAwesomeIcon icon="check" className={classes.CheckMark} />
          <h3>Only show posts with videos</h3>
        </div>
      </div>
      <div className={classes.Controls}>
        <p onClick={props.clear}>Clear</p>
        <p onClick={props.submit}>SAVE</p>
      </div>
    </div>
  );
};

export default fileTypeFilter;
